import React from 'react';

interface FlexProps {
  children: React.ReactNode;
  direction?: 'row' | 'column';
  align?: 'start' | 'center' | 'end' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly';
  gap?: number | string;
  wrap?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Reusable Flex component for consistent flexbox layouts
 * 
 * @example
 * <Flex align="center" gap={8}>
 *   <span>Label</span>
 *   <Icon />
 * </Flex>
 */
export const Flex: React.FC<FlexProps> = ({
  children,
  direction = 'row',
  align = 'start',
  justify = 'start',
  gap = 0,
  wrap = false,
  className = '',
  style = {},
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        gap: typeof gap === 'number' ? `${gap}px` : gap,
        flexWrap: wrap ? 'wrap' : 'nowrap',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

